import {
  Box,
  Button,
  Typography,
  TextField,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import { X } from "phosphor-react";
import { useState } from "react";
import useEnterpriseInfoModalStyles from "./EnterpriseInfoModalStyles";
import { fpost } from "../../API/callsAPI";

const EnterpriseInfoModal = ({ handleClose, handleSubmit, setSnackValue }) => {
  const classes = useEnterpriseInfoModalStyles();

  const [form, setForm] = useState({
    organizationName: "",
    website: "",
    teamSize: "",
    industry: "",
    message: "",
  });

  const handleChange = (key) => (e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const onSubmit = async () => {
    // handleSubmit?.(form);
    console.log(form);
    try {
      const postData = {
        url: "request-enterprise-team/",
        data: {
          organization_name: form?.organizationName,
          website: form?.website,
          user_count_range: form?.teamSize,
          organization_type: form?.industry,
          comment: form?.message,
        },
      };
      const res = await fpost(postData);
      console.log(res);
      setSnackValue({
        isOpen: true,
        message:
          "Your Requested has been submitted, our team will contact with you",
        isError: false,
      });
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  return (
    <Box className={classes.modalWrapper}>
      {/* Header */}
      <Box className={classes.header}>
        <Typography className={classes.title}>
          Additional Info for Enterprise Plan
        </Typography>

        <IconButton onClick={handleClose}>
          <X size={22} color="#F9F9F9" />
        </IconButton>
      </Box>

      {/* Body */}
      <Box className={classes.body}>
        <Typography className={classes.description}>
          We appreciate your interest in our Enterprise plan! To better assist
          you, could you please provide us with more details about your
          organisation?
        </Typography>

        <Typography className={classes.subDescription}>
          Our cloud team will contact you to help setup the Enterprise Plan
          after submission.
        </Typography>

        {/* Row 1 */}
        <Box className={classes.row}>
          <Box className={classes.inputWrapper}>
            <Box className={classes.labelRow}>
              <Typography className={classes.label}>
                Organisation Name
              </Typography>
              <Typography className={classes.required}>*</Typography>
            </Box>

            <TextField
              placeholder="Enter organisation name"
              value={form.organizationName}
              onChange={handleChange("organizationName")}
              fullWidth
              variant="outlined"
              className={classes.textField}
            />
          </Box>

          <Box className={classes.inputWrapper}>
            <Box className={classes.labelRow}>
              <Typography className={classes.label}>Website</Typography>
              <Typography className={classes.required}>*</Typography>
            </Box>

            <TextField
              placeholder="Enter website URL"
              value={form.website}
              onChange={handleChange("website")}
              fullWidth
              variant="outlined"
              className={classes.textField}
            />
          </Box>
        </Box>

        {/* Row 2 */}
        <Box className={classes.row}>
          <Box className={classes.inputWrapper}>
            <Box className={classes.labelRow}>
              <Typography className={classes.label}>Team Size</Typography>
              <Typography className={classes.required}>*</Typography>
            </Box>

            <TextField
              select
              value={form.teamSize}
              onChange={handleChange("teamSize")}
              fullWidth
              variant="outlined"
              className={classes.selectField}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.menuPaper },
                },
              }}
            >
              {["1–10", "11–50", "51–200", "200+"].map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  className={classes.menuItem}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Box className={classes.inputWrapper}>
            <Box className={classes.labelRow}>
              <Typography className={classes.label}>Industry</Typography>
              <Typography className={classes.required}>*</Typography>
            </Box>

            <TextField
              select
              value={form.industry}
              onChange={handleChange("industry")}
              fullWidth
              variant="outlined"
              className={classes.selectField}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.menuPaper },
                },
              }}
            >
              {[
                "Media & Entertainment",
                "Technology",
                "Education",
                "Healthcare",
                "Other",
              ].map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  className={classes.menuItem}
                >
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>

        {/* Message */}
        <Box className={classes.textAreaWrapper}>
          <Box className={classes.labelRow}>
            <Typography className={classes.label}>
              Additional Message
            </Typography>
          </Box>

          <TextField
            placeholder="Tell us more about your requirements..."
            value={form.message}
            onChange={handleChange("message")}
            multiline
            rows={4}
            fullWidth
            variant="outlined"
            className={classes.textArea}
          />
        </Box>
      </Box>

      {/* Footer */}
      <Box className={classes.footer}>
        <Button className={classes.submitButton} onClick={onSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default EnterpriseInfoModal;
